<template>
  <wrap-container>
    <help-title title="Entrega de producto" />

    <help-list-container>
      <help-list-item tituloLista="Banca Online">
        Podés consultar y modificar el domicilio de entrega de tus plásticos en
        <strong>Banca Online</strong>, ingresando con tu DNI, Usuario y Clave
        Digital. <br />En el menú tarjetas: Seleccionar la tarjeta
        correspondiente y a
        <strong>
          "Ver el estado actual" ➜ "Tarjetas en distribución".
        </strong>
        Allí tendrás acceso a la opción <strong>"Repactar envío"</strong> o
        <strong>"Reenviar"</strong>
      </help-list-item>

      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad.
        <contact-link />
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import ContactLink from "@/components/core/ContactLink";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    ContactLink
  }
};
</script>
